import { defaultStyles } from "./variants/bankTransfer.default";
import { paymnentStyles } from "./variants/bankTransfer.payments";

export const bankTransferVariants = {
    default: defaultStyles,
    payments: paymnentStyles
} as const;

export type BankTransferVariant = keyof typeof bankTransferVariants;